import { useEffect, useState } from "react";
import axios from "axios";
import { Box } from "@mui/system";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { v4 as uuidv4 } from "uuid";
import { Button, CssBaseline, Container, TextField } from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";
import Swal from "sweetalert2";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import Avatar from '@mui/material/Avatar';
import Article from "./article";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  Link,
  Grid,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Modal,
} from "@mui/material";


const theme = createTheme();

const stylee = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "white",
  border: "1px solid #e79129",
  boxShadow: 24,
  p: 1,
};

const styleesearch = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "white",
  border: "1px solid #e79129",
  boxShadow: 24,
  p: 1,
};


const Search = () => {

  const URL = "https://api.thaipadi.org"
  
  //checkpin

    const [selecttn, setSelecttn] = useState([]);
    const [selectfname, setSelectfname] = useState([]);
    const [selectlname, setSelectlname] = useState([]);
  
  
    const handleCheckpin = (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const jsondata = JSON.stringify({
        tel: data.get('tel'),
        pin: data.get('pin'),
      });
      var config = {
        method: 'post',
        url: 'https://api.thaipadi.org/checkpin',
        headers: {
          'Content-Type': 'application/json'
        },
        data: jsondata
      };
  
      axios(config)
        .then(function (response) {
          if (response.data.status === 'OK') {
              setSelecttn(response.data.TN);
              setSelectfname(`${response.data.fname}`);
              setSelectlname(`${response.data.lname}`);
              Swal.fire({
                icon: 'success',
                title: 'ยินดีตอนรับสู่ THAIPADI',
                showConfirmButton: false,
                timer: 1500
              }).then((result) => {
                const usersURL1 = `${URL}/manappoinment/`;
                const usersURL2 = `${URL}/appoinment/`;
                const usersURL3 = `${URL}/appoinments/`;
                const usersURL4 = `${URL}/appoinmentss/`;
                const usersURL5 = `${URL}/appoinmentsss/`;
                axios.get(`${usersURL1}${response.data.TN}`).then((res) => {
                  setMandata(res.data);
                });
                axios.get(`${usersURL2}${response.data.TN}`).then((res) => {
                  setData(res.data);
                });
                axios.get(`${usersURL3}${response.data.TN}`).then((res) => {
                  setDatas(res.data);
                });
                axios.get(`${usersURL4}${response.data.TN}`).then((res) => {
                  setDatass(res.data);
                });
                axios.get(`${usersURL5}${response.data.TN}`).then((res) => {
                  setDatasss(res.data);
                });
                handleClosesearch()
                handleOpensearchapp()
              })
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'เบอร์โทรศัพท์หรือรหัสผ่านไม่ถูกต้อง',
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
        .catch(function (error) {
          console.log(error);
        });
  
  
    };
  
  
    const [opensearch, setOpensearch] = useState(false);
    const handleOpensearch = () => setOpensearch(true);
    const handleClosesearch = () => setOpensearch(false);
  
    const [opensearchapp, setOpensearchapp] = useState(false);
    const handleOpensearchapp = () => setOpensearchapp(true);
    const handleClosesearchapp = () => setOpensearchapp(false);
  
  
    //checkpin





  const [mandata, setMandata] = useState([]);
  const mandataL = mandata.length
  const [data, setData] = useState([]);
  const dataL = data.length
  const [datas, setDatas] = useState([]);
  const datasL = datas.length
  const [datass, setDatass] = useState([]);
  const datassL = datass.length
  const [datasss, setDatasss] = useState([]);
  const datasssL = datasss.length

  //จำนวนครั้งที่นัดหมาย
    const Apl = mandataL+dataL+datasL+datassL+datasssL
  //จำนวนครั้งที่นัดหมาย

  // useEffect(() => {
  //   console.log(selecttn)
  //   getdata()
  // }, [selecttn]);

  const getdata = ()=>{
    console.log(selecttn)
    const usersURL1 = `${URL}/manappoinment/`;
    const usersURL2 = `${URL}/appoinment/`;
    const usersURL3 = `${URL}/appoinments/`;
    const usersURL4 = `${URL}/appoinmentss/`;
    const usersURL5 = `${URL}/appoinmentsss/`;
    axios.get(`${usersURL1}${selecttn}`).then((res) => {
      setMandata(res.data);
    });
    axios.get(`${usersURL2}${selecttn}`).then((res) => {
      setData(res.data);
    });
    axios.get(`${usersURL3}${selecttn}`).then((res) => {
      setDatas(res.data);
    });
    axios.get(`${usersURL4}${selecttn}`).then((res) => {
      setDatass(res.data);
    });
    axios.get(`${usersURL5}${selecttn}`).then((res) => {
      setDatasss(res.data);
    });
  }


  //ดึงข้อมูลผิดนัด
  const [datablock, setDatablock] = useState([]);
  const getblock = ()=>{
    const usersURL1 = `${URL}/blocklist/`;
    axios.get(`${usersURL1}${selecttn}`).then((res) => {
      setDatablock(res.data);
    });
  }
  //ดึงข้อมูลผิดนัด


  //cancel
  const alertline = (date) =>{
    const date2= () => {
      return new Date().getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear()
    }
    console.log(date === date2())
    if ( date === date2()) {
      var config = {
        method: "post",
        url: `https://linenotify.thaipadi.org/alertline`,
        headers: {
          "Content-Type": "application/json",
        },
      };
      axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });
      return
    } else{
      return
    }
  }


  //คนที่1
  const confirmcancel1 = (AN,date,time) =>{
    Swal.fire({
      title: 'คำเตือน',
      text: "การยกเลิกนัดหมายติดต่อกันหลายครั้ง มีผลต่อสิทธิ์ในการนัดหมายของท่าน",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยกเลิกนัดหมาย',
      cancelButtonText: 'ปิด'
    }).then((result) => {
      if (result.isConfirmed) {
        alert1(AN,date,time)
      }
    })
  }
  
  const alert1 = (AN,date,time) =>{
    const settime=()=>{
      if(time==="09:00"){
        return "9"
      }
      else if(time === "10:15"){
        return "10"
      }
      else if(time === "13:30"){
        return "13"
      }
      else if(time=== "14:45"){
        return "14"
      }
      else{
        return
      }
    }
    console.log(settime())
    var config = {
      method: "post",
      url: `https://linenotify.thaipadi.org/cancelappoinment/${settime()}/${date}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
    .then(function (response) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldata(AN,date)
        console.log(JSON.stringify(response.data));
    })
      return
    })
    .catch(function (error) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldata(AN,date)
        console.log(error);
    })
      return
    });
  }

  const canceldata = (AN,date) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomen`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if((response.data["status"] === "OK")){
            getdata()
            alertline(date)
      } else {
        alert(JSON.stringify(response.data))
      }
    })
      .catch(function (error) {
        console.log(error);
      });
  };

  //คนที่2
  const confirmcancel2 = (AN,date,time) =>{
    Swal.fire({
      title: 'คำเตือน',
      text: "การยกเลิกนัดหมายติดต่อกันหลายครั้ง มีผลต่อสิทธิ์ในการนัดหมายของท่าน",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยกเลิกนัดหมาย',
      cancelButtonText: 'ปิด'
    }).then((result) => {
      if (result.isConfirmed) {
        alert2(AN,date,time)
      }
    })

  }

  const alert2 = (AN,date,time) =>{
    const settime=()=>{
      if(time==="09:00"){
        return "9"
      }
      else if(time === "10:15"){
        return "10"
      }
      else if(time === "13:30"){
        return "13"
      }
      else if(time=== "14:45"){
        return "14"
      }
      else{
        return
      }
    }
    console.log(settime())
    var config = {
      method: "post",
      url: `https://linenotify.thaipadi.org/cancelappoinments/${settime()}/${date}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
    .then(function (response) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldatas(AN,date)
        console.log(JSON.stringify(response.data));
    })
      return
    })
    .catch(function (error) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldatas(AN,date)
        console.log(error);
    })
      return
    });
  }

  const canceldatas = (AN,date) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomens`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if((response.data["status"] === "OK")){
            getdata()
            alertline(date)
      } else {
        alert(JSON.stringify(response.data))
      }
    })
      .catch(function (error) {
        console.log(error);
      });
  };

  //คนที่3
  const confirmcancel3 = (AN,date,time) =>{
    Swal.fire({
      title: 'คำเตือน',
      text: "การยกเลิกนัดหมายติดต่อกันหลายครั้ง มีผลต่อสิทธิ์ในการนัดหมายของท่าน",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยกเลิกนัดหมาย',
      cancelButtonText: 'ปิด'
    }).then((result) => {
      if (result.isConfirmed) {
        alert3(AN,date,time)
      }
    })

  }

  const alert3 = (AN,date,time) =>{
    const settime=()=>{
      if(time==="09:00"){
        return "9"
      }
      else if(time === "10:15"){
        return "10"
      }
      else if(time === "13:30"){
        return "13"
      }
      else if(time=== "14:45"){
        return "14"
      }
      else{
        return
      }
    }
    console.log(settime())
    var config = {
      method: "post",
      url: `https://linenotify.thaipadi.org/cancelappoinmentss/${settime()}/${date}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
    .then(function (response) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldatass(AN,date)
        console.log(JSON.stringify(response.data));
    })
      return
    })
    .catch(function (error) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldatass(AN,date)
        console.log(error);
    })
      return
    });
  }

  const canceldatass = (AN,date) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomenss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if((response.data["status"] === "OK")){
            getdata()
            alertline(date)
      } else {
        alert(JSON.stringify(response.data))
      }
    })
      .catch(function (error) {
        console.log(error);
      });
  };

  //คนที่5
  const confirmcancel5 = (AN,date,time) =>{
    Swal.fire({
      title: 'คำเตือน',
      text: "การยกเลิกนัดหมายติดต่อกันหลายครั้ง มีผลต่อสิทธิ์ในการนัดหมายของท่าน",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยกเลิกนัดหมาย',
      cancelButtonText: 'ปิด'
    }).then((result) => {
      if (result.isConfirmed) {
        alert5(AN,date,time)
      }
    })

  }

  const alert5 = (AN,date,time) =>{
    const settime=()=>{
      if(time==="09:00"){
        return "9"
      }
      else if(time === "10:15"){
        return "10"
      }
      else if(time === "13:30"){
        return "13"
      }
      else if(time=== "14:45"){
        return "14"
      }
      else{
        return
      }
    }
    console.log(settime())
    var config = {
      method: "post",
      url: `https://linenotify.thaipadi.org/cancelappoinmentsss/${settime()}/${date}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
    .then(function (response) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldatasss(AN,date)
        console.log(JSON.stringify(response.data));
    })
      return
    })
    .catch(function (error) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldatasss(AN,date)
        console.log(error);
    })
      return
    });
  }

  const canceldatasss = (AN,date) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearwomensss`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if((response.data["status"] === "OK")){
            getdata()
            alertline(date)
      } else {
        alert(JSON.stringify(response.data))
      }
    })
      .catch(function (error) {
        console.log(error);
      });
  };

  //คนที่4
  const confirmcancel4 = (AN,date,time) =>{
    Swal.fire({
      title: 'คำเตือน',
      text: "การยกเลิกนัดหมายติดต่อกันหลายครั้ง มีผลต่อสิทธิ์ในการนัดหมายของท่าน",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยกเลิกนัดหมาย',
      cancelButtonText: 'ปิด'
    }).then((result) => {
      if (result.isConfirmed) {
        alert4(AN,date,time)
      }
    })

  }

  const alert4 = (AN,date,time) =>{
    const settime=()=>{
      if(time==="09:00"){
        return "9"
      }
      else if(time === "10:15"){
        return "10"
      }
      else if(time === "13:30"){
        return "13"
      }
      else if(time=== "14:45"){
        return "14"
      }
      else{
        return
      }
    }
    console.log(settime())
    var config = {
      method: "post",
      url: `https://linenotify.thaipadi.org/cancelmanappoinment/${settime()}/${date}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
    .then(function (response) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldataman(AN,date)
        console.log(JSON.stringify(response.data));
    })
      return
    })
    .catch(function (error) {
      Swal.fire({
        icon: 'success',
        title: 'เสร็จสิ้น',
        text:'ยกเลิกนัดหมายเรียบร้อย',
        showConfirmButton: false,
        timer: 2000
      })
      .then((result)=>{
        canceldataman(AN,date)
        console.log(error);
    })
      return
    });
  }

  const canceldataman = (AN,date) => {
    var data = JSON.stringify({
      AN: AN,
    });

    var config = {
      method: "delete",
      url: `${URL}/clearman`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if((response.data["status"] === "OK")){
            getdata();
            alertline(date)
      } else {
        alert(JSON.stringify(response.data))
      }
    })
      .catch(function (error) {
        console.log(error);
      });
  };


  //canceldata

  return (
    <Grid item xs={4} >
      <Paper style={{ backgroundColor: '#18b1b7' }}>
        <Link
          component="button"
          onClick={handleOpensearch}
          underline="none"
          className="article"
        >
          <h1 style={{ color: 'white' }}>ตรวจสอบนัดหมาย</h1>
        </Link>
        <Modal
          open={opensearch}
          onClose={handleClosesearch}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleesearch}>
            <ThemeProvider theme={theme}>
              <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                  sx={{
                    marginTop: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                    <LockOutlinedIcon />
                  </Avatar>
                  <Typography component="h1" variant="h5">
                    กรุณาเข้าสู่ระบบ
                  </Typography>
                  <Box component="form" onSubmit={handleCheckpin} noValidate sx={{ mt: 1 }}>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="tel"
                      label="เบอร์โทรศัพท์"
                      name="tel"
                      type="number"
                      autoComplete="tel"
                      autoFocus
                    />
                    <TextField
                      margin="normal"
                      style={{ marginBottom: '20px' }}
                      required
                      fullWidth
                      name="pin"
                      label="กรุณากรอกรหัส 6 หลัก"
                      type="password"
                      id="pin"
                      autoComplete="current-password"
                    />
                    <Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={8}>
                          <Button
                            color="success"
                            type="submit"
                            fullWidth
                            variant="contained"
                          >
                            เข้าสู่ระบบ
                          </Button>
                        </Grid>
                        <Grid item xs={4}>
                          <Button
                            color="warning"
                            fullWidth
                            variant="contained"
                            onClick={handleClosesearch}
                          >
                            ยกเลิก
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <hr style={{ marginTop: '20px' }} />
                <h5 style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }} >
                  กรณีลืมรหัส 6 หลัก ให้ติดต่อเจ้าหน้าที่เพื่อรีซ็ตรหัสผ่าน
                </h5>
              </Container>
            </ThemeProvider>
          </Box>
        </Modal>
        <Modal
        open={opensearchapp}
        onClose={handleClosesearchapp }
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={stylee}>
          <Paper
            style={{
              marginBottom: "80px",
              marginTop: "100px",
              marginRight: "16px",
              marginLeft: "16px",
            }}
          >
            <div style={{ marginBottom: "16px" }}>
              <h2 style={{ textAlign: "center" }}>ปฏิทินนัดนวด</h2>
              <h3 style={{ textAlign: "center", color: "black" }}>
                คุณ{selectfname} {selectlname}
              </h3>
              <h4 style={{ textAlign: "center", color: "black" }}>
                จำนวนที่นัดทั้งหมด = {Apl}
              </h4>
              <h5 style={{ textAlign: "center", color: "black" }}>
                กรุณาตรวจสอบให้ชัดเจนเนื่องจากไม่ได้เรียงตามวันที่
              </h5>
            </div>
            <TableContainer component={Paper}>
              <table>
                <thead>
                  <tr className="head">
                    <td>
                      <h4>วันที่</h4>
                    </td>
                    <td>
                      <h4>เวลา</h4>
                    </td>
                    <td>
                      <h4>หัตถการ</h4>
                    </td>
                    <td>
                      <h4>เจ้าหน้าที่</h4>
                    </td>
                    <td>
                      <h4>สถานะ</h4>
                    </td>
                  </tr>
                </thead>

                <tbody className="search">
                  {/* คนที่1 */}
                  {data.map((row) => (
                    <tr key={uuidv4()}>
                      <td>{row.date}</td>
                      <td>{row.time} น.</td>
                      <td>{row.service}</td>
                      <td>{row.provider}</td>
                      <td>
                        <Button
                          variant="contained"
                          color="warning"
                          size="small"
                          startIcon={<CancelOutlined />}
                          style={{ margin: "0 0 0 4px" }}
                          // onClick={()=>{
                          //   return canceldata(row.AN)
                          // }}
                          onClick={() => {
                            return confirmcancel1(row.AN,row.date,row.time);
                          }}
                        >
                          ยกเลิก
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {/* คนที่2 */}
                  {datas.map((row) => (
                    <tr key={uuidv4()}>
                      <td>{row.date}</td>
                      <td>{row.time} น.</td>
                      <td>{row.service}</td>
                      <td>{row.provider}</td>
                      <td>
                        <Button
                          variant="contained"
                          color="warning"
                          size="small"
                          startIcon={<CancelOutlined />}
                          style={{ margin: "0 0 0 4px" }}
                          // onClick={()=>{
                          //   return canceldata(row.AN)
                          // }}
                          onClick={()=>{return confirmcancel2(row.AN,row.date,row.time)}}
                        >
                          ยกเลิก
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {/* คนที่3 */}
                  {datass.map((row) => (
                    <tr key={uuidv4()}>
                      <td>{row.date}</td>
                      <td>{row.time} น.</td>
                      <td>{row.service}</td>
                      <td>{row.provider}</td>
                      <td>
                        <Button
                          variant="contained"
                          color="warning"
                          size="small"
                          startIcon={<CancelOutlined />}
                          style={{ margin: "0 0 0 4px" }}
                          // onClick={()=>{
                          //   return canceldata(row.AN)
                          // }}
                          onClick={()=>{return confirmcancel3(row.AN,row.date,row.time)}}
                        >
                          ยกเลิก
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {/* คนที่5 */}
                  {datasss.map((row) => (
                    <tr key={uuidv4()}>
                      <td>{row.date}</td>
                      <td>{row.time} น.</td>
                      <td>{row.service}</td>
                      <td>{row.provider}</td>
                      <td>
                        <Button
                          variant="contained"
                          color="warning"
                          size="small"
                          startIcon={<CancelOutlined />}
                          style={{ margin: "0 0 0 4px" }}
                          // onClick={()=>{
                          //   return canceldata(row.AN)
                          // }}
                          onClick={()=>{return confirmcancel5(row.AN,row.date,row.time)}}
                        >
                          ยกเลิก
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {/* คนที่4 */}
                  {mandata.map((row) => (
                    <tr key={uuidv4()}>
                      <td>{row.date}</td>
                      <td>{row.time} น.</td>
                      <td>{row.service}</td>
                      <td>{row.provider}</td>
                      <td>
                        <Button
                          variant="contained"
                          color="warning"
                          size="small"
                          startIcon={<CancelOutlined />}
                          style={{ margin: "0 0 0 4px" }}
                          // onClick={()=>{
                          //   return canceldata(row.AN)
                          // }}
                          onClick={()=>{return confirmcancel4(row.AN,row.date,row.time)}}
                        >
                          ยกเลิก
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TableContainer>
          </Paper>
        </Box>
      </Modal>
      </Paper>
    </Grid>
  );
};

export default Search;
